import { getProdvmFromDatabridge } from '@xp-utilities/web';
import $window from './window';

const handleAlgonomyProductClick = (event, product = {}, qvEventName = 'quickview:openModal', qvEventDispatchTarget = $window) => {
  const {
    brand: productBrand,
    collection,
    faceout,
    id,
    imageId,
    name,
  } = product;
  const prodvm = getProdvmFromDatabridge();
  const pagevm = 'recommendations';

  const eventDetails = {
    productId: id,
    collectionId: collection,
    imageId,
    productName: name,
    productBrand,
    returnFocus: event.target,
    faceout,
    prodvm,
    pagevm,
  };

  $window.digitalData.set('product.productViewMethod', prodvm);
  $window.digitalData.set('page.pageViewMethod', pagevm);

  const quickviewEvent = new CustomEvent(qvEventName, { detail: eventDetails });

  qvEventDispatchTarget.dispatchEvent(quickviewEvent);
};

export default handleAlgonomyProductClick;
